export class BoxMessage {
    boxId: string;
    action: string;
    message: string;
    params: any;
    data: any;

    constructor(boxId: string, action: string, params?: any, message?:any, data?:any) {
    	this.boxId = boxId;
    	this.action = action;
    	this.params = params;
        this.message = message;
        this.data = data;
	}
}
